module.exports = "/_next/static/images/ua-cf1a4bc62040aab5017924cd7d217155.svg";